import React, {useEffect} from 'react';
import {BlogEntry} from "@varymadellc/my-weed-club-component-library";
import {urlHost} from "@/utils/apiUrl";
import Link from 'next/link';
import BlogViewItemMenu from "@/layout/nav/BlogViewItemMenu";
import Head from "next/head";
import {useAuth} from "@/providers/AuthProvider";
import {apiGet, extractPayloadFromResponse} from "@/services/apiService";
import imagePathFromFile from "@/utils/imagePathFromFile";
import {useSiteMessage} from "@/providers/SiteMessageProvider";
import Page from "@/layout/Page";

export default function PostUuid({post, error}: any) {
    const {user} = useAuth();

    const {setMessage} = useSiteMessage();

    const {authToken} = useAuth();

    const [url, setUrl] = React.useState<string>('');

    const [authorProfileImage, setAuthorProfileImage] = React.useState<string | undefined>();

    const [authorName, setAuthorName] = React.useState<string | undefined>();

    useEffect(() => {
        (async () => {
            if (post?.authorUuid && authToken) {
                try {
                    const response = await apiGet(`/public/account/${post.authorUuid}`, authToken);

                    const {username, file} = await extractPayloadFromResponse(response);

                    setAuthorProfileImage(imagePathFromFile(file[0]));

                    setAuthorName(username);
                } catch(error: any) {
                    setMessage(error.message);
                }
            }
        })()
    }, [authToken, post?.authorUuid]);

    useEffect(() => {
        setUrl(window.location.href);
    }, []);

    return (
        <Page menu={post?.uuid ? <BlogViewItemMenu showEdit={(post?.authorUuid === user?.uuid)} postUuidOrSlug={post.uuid}/> : null}>
            <Head>
                <title>Myweed.club - {String(post?.title).slice(0, 50)}</title>
                <meta name="description" content={String(post?.title).slice(0, 60)}/>
                <meta name="keywords" content={post?.keywords}/>
                {url && <link rel='canonical' href={`${url}`}/>}

                <meta itemProp="name" content="Myweed.club - blog"/>
                <meta itemProp="description" content={String(post?.title)}/>

                <meta name="og:title" content={String(post?.title).slice(0, 60)}/>
                <meta name="og:description" content={post?.title}/>
                <meta name="og:site_name" content="https://Myweed.club"/>
                <meta name="og:type" content="website"/>
            </Head>
            {
                error
                    ? <span className="bg-warning text-warning p-4 rounded">Unable to load this blog post right now. Please try again later.</span>
                    : <BlogEntry authorName={authorName} authorProfileImage={authorProfileImage} className="min-w-full" LinkAs={Link} post={post}/>
            }
            <p className="text-xs m-4 text-gray-500 mx-auto max-w-[800px]">
                The views expressed in this post are solely those of the user and do not represent the opinions or views of MyWeed.Club. Our platform serves as a medium for users to freely express their thoughts and opinions. While we make efforts to monitor content, we cannot guarantee the accuracy or appropriateness of user-generated posts.
                <br/>
                We encourage you to conduct your own fact-checking and research. If you come across any content that is offensive, incorrect, or inappropriate, please report it to us at admin@MyWeed.Club. Your assistance in maintaining a respectful and informative community is greatly appreciated. Thank you.
            </p>
        </Page>
    )
}

export async function getServerSideProps(context: any) {
    const {postUuid} = context.query

    const res = await fetch(`${urlHost}/post/published/${postUuid}`);

    const payload = await res.json();

    const {error = null, post = null} = payload;

    if (error) {
        console.log(error);
    }

    return {
        props: {
            error,
            post
        },
    }
}